const SidebarSecondStatuses = {
    active: 'Active',
    draft: 'Draft',
    archived: 'Archived',
    pending: 'Pending',
} as const;

export default SidebarSecondStatuses;
